// extracted by mini-css-extract-plugin
export var grid = "_1d-0";
export var span1 = "_1d-2";
export var span10 = "_1d-b";
export var span10L = "_1d-z";
export var span10M = "_1d-n";
export var span10Xl = "_1d-1b";
export var span11 = "_1d-c";
export var span11L = "_1d-10";
export var span11M = "_1d-o";
export var span11Xl = "_1d-1c";
export var span12 = "_1d-d";
export var span12L = "_1d-11";
export var span12M = "_1d-p";
export var span12Xl = "_1d-1d";
export var span1L = "_1d-q";
export var span1M = "_1d-e";
export var span1Xl = "_1d-12";
export var span2 = "_1d-3";
export var span2L = "_1d-r";
export var span2M = "_1d-f";
export var span2Xl = "_1d-13";
export var span3 = "_1d-4";
export var span3L = "_1d-s";
export var span3M = "_1d-g";
export var span3Xl = "_1d-14";
export var span4 = "_1d-5";
export var span4L = "_1d-t";
export var span4M = "_1d-h";
export var span4Xl = "_1d-15";
export var span5 = "_1d-6";
export var span5L = "_1d-u";
export var span5M = "_1d-i";
export var span5Xl = "_1d-16";
export var span6 = "_1d-7";
export var span6L = "_1d-v";
export var span6M = "_1d-j";
export var span6Xl = "_1d-17";
export var span7 = "_1d-8";
export var span7L = "_1d-w";
export var span7M = "_1d-k";
export var span7Xl = "_1d-18";
export var span8 = "_1d-9";
export var span8L = "_1d-x";
export var span8M = "_1d-l";
export var span8Xl = "_1d-19";
export var span9 = "_1d-a";
export var span9L = "_1d-y";
export var span9M = "_1d-m";
export var span9Xl = "_1d-1a";
export var stretch = "_1d-1";